const EXPECTED_DATA_STRUCTURE = ["bundle_type", "bundle_components", "bundle_image", "bundle_variant_id"];

const globalBundleAddToCart = async (handle) => {
    const response = await fetch(`/products/${handle}?view=bundle-components`);
    const data = await response.json();
    if (!EXPECTED_DATA_STRUCTURE.every(key => key in data)) {
        console.error("Invalid data structure", data);
        return;
    }

    const { bundle_components, bundle_image, bundle_variant_id } = data;

    const formData = { items: [] };
    const rawItem = {
        id: bundle_variant_id,
        quantity: 1,
        properties: {
        },
    };
    const quantitiesArray = [];

    const bundleComponentsSorted = sortJSON(
        bundle_components,
        "childProductName",
        "asc"
    );

    bundleComponentsSorted.forEach(({ variantId, quantity }) => {
        quantitiesArray.push({
            id: variantId,
            quantity: Number(quantity),
        });
    });

    rawItem.properties["_quantitiesarray"] = JSON.stringify(quantitiesArray);
    rawItem.properties["_bundleimage"] = bundle_image;

    formData.items.push(rawItem);

    const addToCartResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }
    );
    const addToCartData = await addToCartResponse.json();
    if (addToCartData.items.length > 0) {
        updateCartDrawer();
    }
}